import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const useUpdateConversation = _ref => {
  let {
    toast,
    messageCenterLogger,
    resetState,
    apiMessagingService,
    currentConversation,
    hasUnreadMessagesByRecepient
  } = _ref;
  const changeConversationState = async newState => {
    try {
      await apiMessagingService.patch("/conversations/".concat(currentConversation.sid), {
        'state': newState
      });
    } catch (e) {
      toast.error('Sorry, we are unable to send your message at this time. Please try again later. If issue persists, please contact Unite Us Help Center.');
      messageCenterLogger('Conversation state failed to be updated', {}, e);
    }
  };
  const toggleArchiveState = () => {
    var _currentConversation$, _currentConversation$2;
    if (((_currentConversation$ = currentConversation.state) === null || _currentConversation$ === void 0 ? void 0 : _currentConversation$.current) === 'active') {
      if (Object.keys(currentConversation.messagesByDate).length > 0 && hasUnreadMessagesByRecepient) {
        toast.error(/*#__PURE__*/_jsx(_Fragment, {
          children: "This conversation has unread messages and cannot be archived yet."
        }));
      } else {
        changeConversationState('inactive');
        resetState();
        toast.success(/*#__PURE__*/_jsxs(_Fragment, {
          children: ["Conversation archived. ", /*#__PURE__*/_jsx("button", {
            className: "text-action-blue",
            onClick: () => {
              changeConversationState('active');
              resetState();
            },
            children: "Undo"
          })]
        }));
      }
    } else if (((_currentConversation$2 = currentConversation.state) === null || _currentConversation$2 === void 0 ? void 0 : _currentConversation$2.current) === 'inactive') {
      changeConversationState('active');
      resetState();
      toast.success(/*#__PURE__*/_jsxs(_Fragment, {
        children: ["Conversation unarchived. ", /*#__PURE__*/_jsx("button", {
          className: "text-action-blue",
          onClick: () => {
            changeConversationState('inactive');
            resetState();
          },
          children: "Undo"
        })]
      }));
    }
  };
  return {
    toggleArchiveState,
    changeConversationState
  };
};
//# sourceMappingURL=useUpdateConversation.js.map